import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useMaterialUIController } from "context";
import CTLDialogContent from "application/components/styles/CTLDialogContent";

export default function UploadFileDialog({ open, setOpen, onUpload, uploading }) {
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
 
  const handleClose = () => {
    setFile(null);
    setError("");
    setOpen(false);
  };

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (!selected) return;

    if (selected.type !== "text/csv" && !selected.name.endsWith(".csv")) {
      setError("Please select a valid CSV file only.");
      setFile(null);
      return;
    }

    setError("");
    setFile(selected);
  };

  const handleSubmit = () => {
    if (!file) {
      setError("Select CSV file to upload data in asset.");
      return;
    }
    onUpload(file);
     setFile(null);
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle sx={(theme) => CTLDialogContent(theme, { darkMode })}>
        Upload CSV File
      </DialogTitle>

      <DialogContent sx={(theme) => CTLDialogContent(theme, { darkMode })}>
        <input
          type="file"
          accept=".csv"
          onChange={handleFileChange}
          style={{ marginBottom: 10 }}
          disabled={uploading}
        />
        {error && (
          <Typography color="error" variant="body2">
            {error}
          </Typography>
        )}
        {file && (
          <Typography variant="h5" color="text">
            Selected File: {file.name}
          </Typography>
        )}
      </DialogContent>

      <DialogActions sx={(theme) => CTLDialogContent(theme, { darkMode })}>
        <Button
          variant="contained"
          color="secondary"
          disabled={uploading}
          onClick={handleClose}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={uploading}
        >
          {uploading ? (
            <>
              <CircularProgress size={22} /> &nbsp; Uploading...
            </>
          ) : (
            "Upload"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
